import { useEffect, useState } from 'react';
import { compensationApi } from '../../../api/compensation.js';

const PLAN_TYPES = ['merit', 'bonus', 'equity', 'promotion'];

export default function Plans() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState(null);

  function refresh() {
    setLoading(true);
    compensationApi
      .listPlans()
      .then((d) => setItems(d?.items || []))
      .catch((e) => setError(e.response?.data?.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }
  useEffect(refresh, []);

  async function submit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    let config = {};
    const raw = fd.get('config');
    if (raw) {
      try { config = JSON.parse(raw); } catch { setError('Config must be valid JSON'); return; }
    }
    try {
      await compensationApi.createPlan({
        name: fd.get('name'),
        type: fd.get('type') || 'merit',
        description: fd.get('description') || null,
        config,
      });
      form.reset();
      setShowForm(false);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create plan');
    }
  }

  return (
    <section data-testid="comp-plans-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <div>
          <h1>Compensation Plans</h1>
          <p className="muted">{items.length} plans</p>
        </div>
        <button className="btn primary" data-testid="comp-plan-create" onClick={() => setShowForm((s) => !s)}>{showForm ? 'Close' : '+ New Plan'}</button>
      </header>

      {error && <div className="alert error" data-testid="comp-plans-error">{error}</div>}

      {showForm && (
        <form onSubmit={submit} className="card form-card grid-form">
          <label>Name<input name="name" data-testid="comp-plan-name-input" required /></label>
          <label>Type
            <select name="type" data-testid="comp-plan-type-input" defaultValue="merit">
              {PLAN_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </label>
          <label className="full">Description<input name="description" /></label>
          <label className="full">Matrix config (JSON)
            <textarea name="config" rows={4} placeholder='{"defaultPct":0,"guidelines":[{"rating":"exceeds","maxCompaRatio":0.9,"pct":10}]}' />
          </label>
          <div className="full actions"><button className="btn primary" type="submit" data-testid="comp-plan-submit">Create plan</button></div>
        </form>
      )}

      <div className="card">
        <table className="data-table" data-testid="comp-plan-list">
          <thead><tr><th>Name</th><th>Type</th><th>Description</th><th>Guidelines</th></tr></thead>
          <tbody>
            {items.map((p) => {
              const cfg = typeof p.config === 'string' ? JSON.parse(p.config || '{}') : p.config || {};
              const count = Array.isArray(cfg.guidelines) ? cfg.guidelines.length : 0;
              return (
                <tr key={p.id} data-testid={`comp-plan-row-${p.id}`}>
                  <td>{p.name}</td>
                  <td><span className={`chip status-${p.type}`}>{p.type}</span></td>
                  <td>{p.description || '—'}</td>
                  <td>{count} rule{count === 1 ? '' : 's'}</td>
                </tr>
              );
            })}
            {!loading && items.length === 0 && <tr><td colSpan={4} className="muted">No plans yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
